import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';

import { TwoFactorMethodDialogComponent } from '../login/dialogs/two-factor-method-dialog/two-factor-method-dialog.component';
import { RoleSelectionDialogComponent } from '../login/dialogs/role-selection-dialog/role-selection-dialog.component';
import { LocationSelectionDialogComponent } from '../login/dialogs/location-selection-dialog/location-selection-dialog.component';

@NgModule({
  declarations: [
    TwoFactorMethodDialogComponent,
    RoleSelectionDialogComponent,
    LocationSelectionDialogComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    MatCheckboxModule,
    MatIconModule,
  ],
  exports: [
    TwoFactorMethodDialogComponent,
    RoleSelectionDialogComponent,
    LocationSelectionDialogComponent,
  ],
})
export class AuthSharedDialogsModule {}
